export enum Analyzers {
    BASIC,
    JOYSTICK,
    TRIGGER,
    HAPTIC,
}
